module.exports = __webpack_public_path__ + "img/mask-circle.9aa43c86.svg";